import {connect} from 'react-redux';
import TabTaxAuthority from './TabTaxAuthority';
import {getStep9GridTab1} from '../../actions/steps/getStep9Grid';
import {setStep9Page} from '../../actions/steps/setStep9Page';
import {getStep9GridForExcel} from '../../actions/steps/getStep9GridForExcel';
import {saveTaxAuthorityRow} from '../../actions/steps/step9SaveRow';
import {showLittlePopup} from '../../actions/step9LittlePopup';
import {actions as A} from '../../constants/actions';
import {api} from '../../constants/api';
import {saveTab1Filters} from '../../actions/step9SaveTabFilters';

const mapStateToProps = ({
                           step9TaxAuthority: {list, page, totalPages, totalResultCount, loading},
                           step9Filters: {tab1}
                         }) => ({
  list,
  page,
  totalPages,
  totalResultCount,
  loading,
  previousFilters: tab1,
});

export default connect(
  mapStateToProps,
  {
    getStep9GridTaxAuthority: getStep9GridTab1({
      actions: {
        pending: A.GET_STEP_9_GIRD_TAX_AUTHORITY,
        success: A.GET_STEP_9_GIRD_TAX_AUTHORITY_SUCCESS,
        failure: A.GET_STEP_9_GIRD_TAX_AUTHORITY_FAILURE,
        setPage: A.SET_STEP_9_GIRD_TAX_AUTHORITY_PAGE,
      },
      api: api.GET_STEP_9_TAX_AUTHORITY,
    }),
    setStep9TaxAuthorityPage: setStep9Page(A.SET_STEP_9_GIRD_TAX_AUTHORITY_PAGE),
    getStep9GridTaxAuthorityForExcel: getStep9GridForExcel({
      actions: {
        pending: A.GET_STEP_9_GRID_TAX_AUTHORITY_FOR_EXCEL,
        success: A.GET_STEP_9_GRID_TAX_AUTHORITY_FOR_EXCEL_SUCCESS,
        failure: A.GET_STEP_9_GRID_TAX_AUTHORITY_FOR_EXCEL_FAILURE,
      },
      api: api.GET_STEP_9_TAX_AUTHORITY_FOR_EXCEL,
    }),
    saveRow: saveTaxAuthorityRow,
    saveFilters: saveTab1Filters,
    showLittlePopup,
  }
)(TabTaxAuthority);
